<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
      <!-- Alert message -->
      <div>
        <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
      </div>
  
      <!-- Title-->
      <header-component :headerTitle="headerText" />
  
      <!-- update logistics details popup -->
      <v-row justify="center">
        <v-dialog v-model="updateLogisticsPopup" persistent max-width="860px">
          <v-card class="v-card-100">
            <v-card class="v-card-100">
              <v-card-title class="d-flex">
                <v-row class="pa-2">
                  <span>Update Logistics Details</span>
                  <v-spacer></v-spacer>
                  <!-- <v-btn icon variant="solo" > -->
                    <v-icon @click="updateLogisticsPopup = false">mdi-close</v-icon>
                  <!-- </v-btn> -->
                </v-row>
              </v-card-title>
            </v-card>
            <v-card-text class="pb-0">
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <v-menu v-model="suggestPickUpPopup" :close-on-content-click="false" :return-value.sync="suggestedPickupDate" transition="scale-transition" offset-y min-width="auto">
                      <template #activator="{ props }">
                        <v-text-field v-model="formatSuggestPickDate" label="Suggested Pickup Date" variant="outlined" append-inner-icon="mdi-calendar" readonly v-bind="props"> </v-text-field>
                      </template>
                      <v-card class="m-0 overflow-hidden calendar-layout" width="315">
                        <v-date-picker :min="new Date().toISOString().substr(0, 10)" v-model="suggestedPickupDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                        </v-date-picker>
                        <v-card-action class="d-flex justify-end pb-3 pr-2">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" variant="outlined" class="text-none mr-2" @click="suggestedPickupDate = false"> Cancel </v-btn>
                          <v-btn text color="primary" variant="flat" class="text-none" @click="handleSaveDate('suggestPickUpPopup', 'suggPickupDateFormat', 'suggestedPickupDate')"> Ok </v-btn>
                        </v-card-action>
                      </v-card>
                    </v-menu>
                  </v-col>
                  <v-col cols="6">
                    <v-menu ref="endDatemenu" v-model="actualPickUpPopup" :close-on-content-click="false" :return-value.sync="actualPickupDate" transition="scale-transition" offset-y min-width="auto">
                      <template #activator="{ props }">
                        <v-text-field v-model="formatActualPickDate" label="Actual Pickup Date" variant="outlined" append-inner-icon="mdi-calendar" readonly v-bind="props"> </v-text-field>
                      </template>
                      <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                        <v-date-picker :min="actualPickupMin || suggestedPickupDate" :max="actualPickupMax" v-model="actualPickDateFormat" hide-header color="primary" min-width="200" max-width="300" scrollable>
                        </v-date-picker>
                        <v-card-action class="d-flex justify-end pb-3 pr-2">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" variant="outlined" class="text-none mr-2" @click="actualPickUpPopup = false"> Cancel </v-btn>
                          <v-btn text color="primary" variant="flat" class="text-none" @click="handleSaveDate('actualPickUpPopup', 'actualPickDateFormat', 'actualPickupDate')"> Ok </v-btn>
                        </v-card-action>
                      </v-card>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-text-field label="Dispatch Document Number" v-model="dispatchDocumentNumber" variant="outlined"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-file-input v-model="dispatchDocument" label="Dispatch Document" variant="outlined"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-menu ref="receiptMenu" v-model="receiptDatePopup" :close-on-content-click="false" :return-value.sync="receiptDate" transition="scale-transition" offset-y min-width="auto">
                      <template #activator="{ props }">
                        <v-text-field v-model="formatReceiptDate" label="Receipt Date" variant="outlined" append-inner-icon="mdi-calendar" readonly v-bind="props"> </v-text-field>
                      </template>
                      <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                        <v-date-picker :min="new Date().toISOString().substr(0, 10)" v-model="receiptDateFormat" hide-header color="primary" min-width="200" max-width="300" scrollable>
                        </v-date-picker>
                        <v-card-action class="d-flex justify-end pb-3 pr-2">
                          <v-spacer></v-spacer>
                          <v-btn text class="text-none mr-2" variant="outlined" color="primary" @click="receiptDatePopup = false"> Cancel </v-btn>
                          <v-btn text class="text-none" variant="flat" color="primary" @click="handleSaveDate('receiptDatePopup', 'receiptDateFormat','receiptDate')"> OK </v-btn>
                        </v-card-action>
                      </v-card>
                    </v-menu>
                  </v-col>
                  <v-col cols="6">
                    <v-file-input v-model="receiptFile" label="Receipt" variant="outlined"/>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions center class="pb-4">
              <v-spacer></v-spacer>
              <v-btn class="text-none" variant="flat" color="primary" :disabled="number > 0 || !suggestedPickupDate" @click="saveAndClose">Save & Close</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- assignee popup -->
      <v-row justify="center">
        <v-dialog v-model="assigneePopup" persistent max-width="860px">
          <v-card class="v-card-100">
            <v-card class="v-card-100">
              <v-card-title class="d-flex">
                <span>Change Logistics Partner Assignment</span>
                <v-spacer></v-spacer>
                <v-btn icon variant="solo" @click="assigneePopup = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
            <v-card-text class="pb-0">
              <v-row>
                <v-col cols="12" sm="5" md="6">
                  <v-autocomplete prepend-inner-icon="mdi-magnify" label="Logistics Partner" item-title="name" item-value="id" v-model="tracker_logisticsPartner" :items="tracker_logisticsPartnerList" variant="outlined"/>
                </v-col>
                <v-col cols="12" sm="5" md="6">
                  <v-autocomplete prepend-inner-icon="mdi-magnify" label="Assign To" item-title="username" item-value="id" v-model="tracker_assign_to" :items="tracker_assignedToList" variant="outlined"/>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions center class="pb-4">
              <v-spacer></v-spacer>
              <v-btn color="primary" class="text-none" :disabled="number > 0" @click="submitAssignee">Save & Close</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- Update  popup  -->
      <v-row justify="center">
        <v-dialog v-model="requestPopup" persistent max-width="860px">
          <v-card class="v-card-100">
              <v-card-title class="d-flex align-center">
                <span>{{ requestTitle }}</span>
                <v-spacer></v-spacer>
                <v-btn icon variant="solo" @click="requestPopup = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider :thickness="2" class="border-opacity-25 m-0"/>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-tabs v-model="tab_index">
                      <v-tab class="component-tab-heading" ripple :href="'#'" @click="updatePackingRequestTab(tab)" style="text-transform:none!important;text-decoration: none;" v-for="tab in packingRequestTab" :key="tab">
                        {{ tab }}
                      </v-tab>
                    </v-tabs>
                  </v-row>
                  <div v-if="packing_active_tab == 'Items In The Request'">
                    <v-layout column>
                      <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                        <v-list-item-content>
                          <v-data-table 
                            :dense="true"
                            :headers="packingRequestHeader"
                            :items="packingRequestTableData" 
                            style="max-height: 300px; overflow: scroll;" 
                            disable-pagination 
                            :hide-default-footer="true"
                            :loading="loading"
                            class="elevation-1">
                            <template #[`item.action`]="{ item }">
                              <img @click="deleteEvent(item)" src="@/assets/images/delete_red.png" title="Delete item" />
                            </template>
                          </v-data-table>
                        </v-list-item-content>
                      </v-col>
                    </v-layout>
                  </div>
                  <div v-if="packing_active_tab == 'Update Details'">
                    <div v-if="buttonAction == 'create_logistics_request'">
                      <v-row class="mt-4">
                        <v-col cols="12" sm="5" md="6">
                          <!-- <v-autocomplete prepend-inner-icon="mdi-magnify" label="Pick Up Location" item-title="name" item-value="id" return-object v-model="pickUpLoc" :items="pickUpLocList" variant="outlined"/> -->
                          <v-text-field class="ml-2" prepend-inner-icon="mdi-magnify" v-model="pickUpLoc" label="Pick Up Location" variant="outlined"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="5" md="6">
                          <v-autocomplete prepend-inner-icon="mdi-magnify" label="Delivery Location" item-title="code" item-value="id" return-object v-model="deliveryLoc" :items="deliveryLocList" variant="outlined"/>
                        </v-col>
                      </v-row>
                      <v-row>
                        <p class="ml-4 mb-0">Item Validation required?</p>
                      </v-row>
                      <v-radio-group row class="mt-0 pt-0" v-model="itemValidRequest">
                        <v-col cols="12" sm="5" md="6" class="pl-0">
                          <v-radio label="True" value="true"></v-radio>
                        </v-col>
                        <v-col cols="12" sm="5" md="6" class="pl-0">
                          <v-radio label="False" value="false"></v-radio>
                        </v-col>
                      </v-radio-group>
                      <v-row>
                        <p class="ml-4 mb-0">Fraud Validation required?</p>
                      </v-row>
                      <v-radio-group row class="mt-0 pt-0" v-model="fraudValidRequest">
                        <v-col cols="12" sm="5" md="6" class="pl-0">
                          <v-radio label="True" value="true"></v-radio>
                        </v-col>
                        <v-col cols="12" sm="5" md="6" class="pl-0">
                          <v-radio label="False" value="false"></v-radio>
                        </v-col>
                      </v-radio-group>
                      <v-row>
                        <v-col cols="12" sm="5" md="6">
                          <v-autocomplete prepend-inner-icon="mdi-magnify" label="Logistics Partner" item-title="name" item-value="id" return-object v-model="logisticsPartner" :items="logisticsPartnerList" variant="outlined"/>
                        </v-col>
                        <v-col cols="12" sm="5" md="6">
                          <v-autocomplete prepend-inner-icon="mdi-magnify" label="Assign To" item-title="username" item-value="id" return-object v-model="assign_to" :items="assignedToList" variant="outlined"/>
                        </v-col>
                      </v-row>
                    </div>
                    <div v-if="buttonAction == 'create_packing_request'">
                      <v-row class="mt-4">
                        <v-col cols="12" sm="5" md="6">
                          <!-- <v-text-field label="Request Reason" v-model="request_reason" variant="outlined" disabled/> -->
                          <v-autocomplete prepend-inner-icon="mdi-magnify" label="Request Reason" item-title="name" item-value="id" return-object v-model="request_reason" :items="request_reason_list" variant="outlined" disabled/>
                        </v-col>
                        <v-col cols="12" sm="5" md="6">
                          <v-autocomplete prepend-inner-icon="mdi-magnify" label="Assign To" item-title="username" item-value="id" return-object v-model="assign_to" :items="assignedToList" variant="outlined"/>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-container>
              </v-card-text>
            <v-card-actions center>
              <v-spacer></v-spacer>
              <v-btn variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="requestPopup = false">Cancel</v-btn>
              <!-- <v-btn color="primary" v-if="buttonAction == 'create_logistics_request'" class="mb-3" :disabled="!pickUpLoc || !deliveryLoc || !itemValidRequest || !fraudValidRequest || !logisticsPartner || !assign_to || number > 0" @click="submitPackingRequest">Submit</v-btn> -->
              <v-btn color="primary" variant="flat" class="mb-3 text-none" :disabled="number > 0" @click="submitPackingRequest">Submit</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- reference popup -->
      <v-row justify="center">
        <v-dialog v-model="referenceDocPopup" persistent max-width="700px">
          <v-card class="v-card-100">
            <v-card class="v-card-100 mt-0">
              <v-card-title class="d-flex">
                <span>Reference Doc No:</span><span style="font-weight:300">{{ itemInformation.return_order_number }}
                </span>
                <v-spacer></v-spacer>
                <!-- <v-btn icon @click="referenceDocPopup = false"> -->
                  <v-icon @click="referenceDocPopup = false">mdi-close</v-icon>
                <!-- </v-btn> -->
              </v-card-title>
            </v-card>
            <v-container style="height:50vh" class="overflow-y-auto overflow-x-hidden pa-0">
              <v-card-text>
                <span class="replacement-style">Replacement Item</span>
                <v-row>
                  <v-col cols="3" sm="3" md="3">
                    <span style="font-weight: 600;color:#0357D0;">ORRD Number</span>
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    {{ referenceDocData.orrd_number ? referenceDocData.orrd_number : '-' }}
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    <span style="font-weight: 600;color:#0357D0;">ORRD Type</span>
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    {{ referenceDocData.orrd_type ? referenceDocData.orrd_type : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" sm="3" md="3">
                    <span style="font-weight: 600;color:#0357D0;">Item Count</span>
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    {{ referenceDocData.rep_items_count ? referenceDocData.rep_items_count : '-' }}
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    <span style="font-weight: 600;color:#0357D0;">ORD Number</span>
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    {{ referenceDocData.ord_number ? referenceDocData.ord_number : '-' }}
                  </v-col>
                </v-row>
                    
                <div>
                  <v-layout column>
                    <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                      <v-list-item-content class="p-0">
                        <v-data-table 
                          :dense="true"
                          :headers="itemsHeaders"
                          :items="items_table_rep"
                          style="max-height: 300px;height:auto !important;border-bottom: 1px solid #ddd;" 
                          disable-pagination 
                          :hide-default-footer="true"
                          class="elevation-1" return-object>
                          <template #[`item.weight`]="{ item }">
                            <span>-</span>
                          </template>
                          <template #[`item.volumetric_weight`]="{ item }">
                            <span>-</span>
                          </template>
                          <template #bottom></template>
                        </v-data-table>
                      </v-list-item-content>
                    </v-col>
                  </v-layout>
                </div>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Pickup Location Details</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ referenceDocData.rep_pickup_location_details ? referenceDocData.rep_pickup_location_details : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Pickup Location Contact Details</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Drop Location Details</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ referenceDocData.rep_drop_location_details ? referenceDocData.rep_drop_location_details : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Drop Location Contact Details</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ '-' }}
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text class=pt-0>
                <span v-if="request_type_condi === 'Replacement'" class="replacement-style">Return Item</span>
                <v-row>
                  <v-col cols="3" sm="3" md="3">
                    <span style="font-weight: 600;color:#0357D0;">IRRD Number</span>
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    {{ referenceDocData.irrd_number ? referenceDocData.irrd_number : '-' }}
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    <span style="font-weight: 600;color:#0357D0;">IRRD Type</span>
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    {{ referenceDocData.irrd_type ? referenceDocData.irrd_type : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" sm="3" md="3">
                    <span style="font-weight: 600;color:#0357D0;">Item Count</span>
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    {{ referenceDocData.items_count ? referenceDocData.items_count : '-' }}
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    <span style="font-weight: 600;color:#0357D0;">IRD Number</span>
                  </v-col>
                  <v-col cols="3" sm="3" md="3">
                    {{ referenceDocData.ird_number ? referenceDocData.ird_number : '-' }}
                  </v-col>
                </v-row>
                    
                <div>
                  <v-layout column>
                    <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
                      <v-list-item-content class="p-0">
                        <v-data-table 
                          :dense="true"
                          :headers="itemsHeaders"
                          :items="itemsTableData"
                          style="max-height: 300px;height:auto !important;border-bottom: 1px solid #ddd;" 
                          disable-pagination 
                          :hide-default-footer="true"
                          class="elevation-1">
                          <template #[`item.weight`]="{ item }">
                            <span>-</span>
                          </template>
                          <template #[`item.volumetric_weight`]="{ item }">
                            <span>-</span>
                          </template>
                          <template #bottom></template>
                        </v-data-table>
                      </v-list-item-content>
                    </v-col>
                  </v-layout>
                </div>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Pickup Location Details</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ referenceDocData.pickup_location_details ? referenceDocData.pickup_location_details : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Pickup Location Contact Details</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Drop Location Details</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ referenceDocData.drop_location_details ? referenceDocData.drop_location_details : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Drop Location Contact Details</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ '-' }}
                  </v-col>
                </v-row>
              </v-card-text>
            </v-container>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- details Popup -->
      <v-row justify="center">
        <v-dialog v-model="logisticPopup" persistent max-width="700px">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <span>Sub-Request ID "{{ itemInformation.return_request_id }}" 
              <!-- <span class="assets">Assignment Date: {{ itemInformation.created_date }}</span> -->
              </span>
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="logisticPopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="2" class="border-opacity-25 m-0"/>
            <v-card-text>
            <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Return Request ID</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.return_request_id ? itemInformation.return_request_id : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Return Sub Request ID</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.return_sub_request_id ? itemInformation.return_sub_request_id : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Return Type</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.return_type ? itemInformation.return_type : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Article ID</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.sku_code ? itemInformation.sku_code : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Article Description</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.sku_description ? itemInformation.sku_description : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Serial Number</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.serial_number ? itemInformation.serial_number : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Created Date</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.created_date ? itemInformation.created_date : '-' }}
                  </v-col>
                </v-row>
                
              <!-- <div>
              <v-tabs class="mt-1">
                <v-tab class="component-tab-heading"ripple :href="'#'" v-for="tab in logisticTabs" :key="tab" @click="changeTabs(tab)" style="text-transform:none!important; text-decoration: none!important;" >{{ tab }}</v-tab>
              </v-tabs>
              <div v-if="activeTab === 'Basic Details'">
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Logistics Partner</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.logistics_partner ? itemInformation.logistics_partner : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Logistics Executive</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.logistics_executive ? itemInformation.logistics_executive : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Item Validation Required?</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.item_validation_required ? itemInformation.item_validation_required : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Fraud Validation Required?</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.fraud_validation_required ? itemInformation.fraud_validation_required : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Pickup Location</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.pick_up_location ? itemInformation.pick_up_location : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Delivery Location</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.delivery_location ? itemInformation.delivery_location : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Suggested Pick Up Date</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.suggested_pickup_date ? itemInformation.suggested_pickup_date : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Actual Pick Up Date</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.actual_pickup_date ? itemInformation.actual_pickup_date : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <span style="font-weight: 500;">Status</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    {{ itemInformation.status ? itemInformation.status : '-' }}
                  </v-col>
                </v-row>
              </div>
              <div v-if="activeTab === 'Items In The Request'">
                <v-layout column>
                  <v-flex md6 style="overflow: auto">
                    <v-list-item-content class="p-0">
                      <v-data-table 
                        :dense="true"
                        :headers="itemsHeaders"
                        :items="itemsTableData" 
                        style="max-height: 300px;" 
                        disable-pagination 
                        :hide-default-footer="true"
                        class="elevation-1">
                        <template v-for="(itemsHeaders, index) in itemsHeaders" v-slot:[`item.${itemsHeaders.value}`]="{ item }">
                          <span v-if="itemsHeaders.value !== 'logistics_request_id'">
                            <span v-if="item[itemsHeaders.value] !== null && item[itemsHeaders.value] !== ''">
                              {{ item[itemsHeaders.value] }}
                            </span>
                            <span v-else>
                              <span>-</span>
                            </span>
                          </span>
                        </template>
                      </v-data-table>
                    </v-list-item-content>
                  </v-flex>
                </v-layout>
              </div>
            </div> -->
            </v-card-text>
          </v-card>
            
        </v-dialog>
      </v-row>
      <!-- details popup -->
      <v-row justify="center">
        <v-dialog v-model="datadetailpopup" persistent max-width="700px">
          <v-card class="v-card-100">
            <v-card class="v-card-100">
              <v-card-title class="d-flex">
                <span>Request ID: "{{ item_details.request_id }}"</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="datadetailpopup = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
            <v-card-text>
              <v-container>
                <div>
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <span style="font-weight: 500;">Request id</span>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      {{ item_details.request_id }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <span style="font-weight: 500;">Creation Date & Time</span>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      {{ item_details.created_at }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <span style="font-weight: 500;">Request Type</span>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      {{ item_details.request_type }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <span style="font-weight: 500;">Assigned To</span>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      {{ item_details.assignee_name ? item_details.assignee_name : '-' }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <span style="font-weight: 500;">Status</span>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      {{ item_details.Status ? item_details.Status : '-' }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <span style="font-weight: 500;">Completion Date & Time</span>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      {{ '-' }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <span style="font-weight: 500;">Not Found items</span>
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                      {{ item_details.not_found_items ? item_details.not_found_items : 0 }}
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
      <!--Success Message popup -->
      <v-row justify="center">
        <v-dialog v-model="messagePopup" persistent max-width="424px">
          <v-card class="v-card-100 pa-2">
            <v-card-title class="d-flex">
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="messagePopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="text-center">
              <span> {{ message }} </span>
            </v-card-text>
            <v-card-actions center>
              <v-spacer></v-spacer>
              <v-btn v-if="!markAsPacked"  variant="flat"  color="primary" class="mb-3 text-none" @click="closePopup">Ok</v-btn>
              <v-btn v-if="markAsPacked"  variant="flat" color="primary" class="mb-3 mr-2 text-none" @click="confirmedMarkAsPacked">Confirm</v-btn>
              <v-btn v-if="markAsPacked" variant="outlined" color="primary" class="mb-3 text-none" @click="messagePopup = false">Cancel</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- filter popup -->
      <v-row justify="center">
        <v-dialog content-class="filter-data" v-model="filterPopup" persistent max-width="1224px">
          <v-card>
            <v-card-actions >
              <v-text-field v-if="active_tab == 'Reverse Pickup' || active_tab == 'Other Logistics Requests' || active_tab == 'Update Logistics Details'" class="ml-2" prepend-inner-icon="mdi-magnify" v-model="filter_pickup_location" label="Pick up Location" variant="outlined"></v-text-field>
              <v-combobox v-if="active_tab == 'Reverse Pickup' || active_tab == 'Other Logistics Requests' || active_tab == 'Update Logistics Details'" clearable v-model="filter_delivery_location" :items="filter_delivery_location_items" item-title="code" item-value="id" label="Delivery Location" variant="outlined" class="ma-2"></v-combobox>
              <v-combobox v-if="active_tab == 'Request Tracker'" clearable v-model="request_type_search" :items="filter_request_types" item-title="name" item-value="id" label="Request Type" variant="outlined" class="ma-2" return-object></v-combobox>
              <v-combobox v-if="active_tab == 'Request Tracker'" clearable v-model="status_search" :items="filter_status" item-title="name" item-value="id" label="Status" variant="outlined" class="ma-2" return-object></v-combobox>
              <v-combobox v-if="active_tab == 'Update Logistics Details'" clearable v-model="filter_logistic_partner" :items="filter_logistic_partner_items" item-title="name" item-value="id" label="Logistics Partner" variant="outlined" class="ma-2" return-object></v-combobox>
               <v-combobox v-if="active_tab == 'Reverse Pickup' || active_tab == 'Other Logistics Requests'" clearable v-model="status" :items="status_items"  label="Status" variant="outlined" class="ma-2" return-object></v-combobox>
               <v-text-field v-if="active_tab == 'Update Logistics Details'" class="ml-2" prepend-inner-icon="mdi-magnify" v-model="status_update_logi" label="Status" variant="outlined"></v-text-field>
            </v-card-actions>
            <v-card-actions class="margin-10">
              <v-spacer></v-spacer>
              <v-btn small class="text-none"  text color="normal" @click="filterPopup = false">Cancel</v-btn>
              <v-btn small class="text-none"  color="primary" @click="applyFilterFunc">Apply Filter(s)</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
  
      <!-- tabs -->
      <v-card class="v-card-100 mt-6">
        <v-tabs color="primary">
          <v-tab @click="loadData(tab, 'tab_clicked')" v-for="(tab, index) in tabs" :key="index" class="tab-color" style="text-transform:none!important;">{{ tab }}</v-tab>
        </v-tabs>
      </v-card>
  
      <v-card-title style="padding: 28px 24px 4px 24px;" class="action-style">
        <!-- Search fields -->
        <v-row cols="12" md="4" sm="12" lg="4" xl="3" class="d-flex align-center">
          <v-combobox v-if="active_tab === 'Reverse Pickup' || active_tab === 'Other Logistics Requests'" v-model="selected_field" :items="field_items" item-title="name" item-value="id" label="Select Field" variant="outlined" style="max-width: 150px;" return-object >
          </v-combobox>
          <v-text-field class="ma-2" prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" style="max-width: 280px;" variant="outlined" v-on:keyup.enter="loadData(active_tab)">
          </v-text-field>
  
          <v-spacer></v-spacer>
          <!-- Actions buttons -->
          <v-card-actions style="margin-bottom: 15px;padding-top: 0px; padding-bottom: 0px;">
            <v-btn class="mr-2 text-none" color="primary" variant="flat" :disabled="selected.length == 0" size="x-large" v-if="active_tab === 'Reverse Pickup' || active_tab === 'Other Logistics Requests'" @click = "createRequest('logistics')">Create Logistics Request</v-btn>
            <!-- <v-btn class="mr-2" color="primary" :disabled="selected.length == 0" v-if="active_tab === 'Reverse Pickup' || active_tab === 'Other Logistics Requests'" @click = "createRequest('packing')">CREATE PACKING REQUEST</v-btn> -->
            <v-btn class="mr-2 text-none" color="primary" size="x-large" variant="flat" :disabled="selected.length == 0" v-if="active_tab === 'Reverse Pickup' || active_tab === 'Other Logistics Requests'" @click = "askForPacking">Mark As Packed</v-btn>  
            <v-btn class="mr-2 text-none" color="primary" size="x-large" variant="flat" :disabled="selected.length == 0" v-if="active_tab === 'Request Tracker'" @click="changeAssignee">Change Assignment</v-btn>  
            <v-btn class="mr-2 text-none" color="primary" size="x-large" variant="flat" :disabled="selected.length == 0" v-if="active_tab === 'Update Logistics Details'" @click="updateLogisticsDetails">Update</v-btn>
          </v-card-actions>
          <!-- Filter -->
          <v-expansion-panels class="custom-control_outlined" ref="filterPopupRef" readonly style="max-width: 300px; margin-bottom: 18px; min-height: 52px" v-if="active_tab !== 'Update Logistics Details'">
            <v-expansion-panel variant="outlined" @click="filterListOfButtons">
              <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-card-title>
  
  
      <!-- Data Table -->
      <v-layout column>
        <v-col cols="12" sm="6" md="12" class="pa-0 pb-3">
          <v-data-table
            density="compact"
            :search="search"
            v-model="selected"
            show-select
            disable-pagination
            :hide-default-footer="true"
            :headers="headers"
            :items="table_data"
            :loading="loading"
            fixed-header
            height="100%"
            :items-per-page="pageSize"
            return-object
            loading-text="Loading Data... Please wait"
            class="elevation-1"
          >
          <template v-for="(header, index) in headers" :key="index" v-slot:[`item.${header.key}`]="{ item }">
            <span v-if="header.key === 'request_id'">
              <template v-if="active_tab === 'Update Logistics Details'">
                <a style="color: #1976d2; cursor: pointer;" @click="DetailsPopup(item)">
                  <u>{{ item.logistics_request_id }}</u>
                </a>
              </template>
              <template v-else-if="active_tab === 'Request Tracker'">
                <a style="color: #1976d2; cursor: pointer;" @click="DetailsPopupRequestTrack(item)">
                  <u>{{ item.request_id }}</u>
                </a>
              </template>
            </span>

            <span v-else-if="header.key === 'item_location' && item[header.key]">
              <span v-tooltip="item[header.key]">
                {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
              </span>
            </span>

            <span v-else-if="header.key === 'delivery_location' && item[header.key]">
              <span v-tooltip="item[header.key]">
                {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
              </span>
            </span>

            <span v-else-if="header.key === 'logistic_partner' && item[header.key]">
              <span v-tooltip="item[header.key]">
                {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
              </span>
            </span>

            <span v-else-if="header.key === 'actual_pickup_date'">
              {{ item[header.key] || '-' }}
            </span>

            <span v-else-if="header.key === 'client_crm_ticket_no' && active_tab === 'Update Logistics Details'">
              <a v-if="item.client_crm_ticket_no" @click="TicketPopup(item)" style="color: #1976d2; cursor: pointer;">
                <u>{{ item.client_crm_ticket_no }}</u>
              </a>
            </span>

            <span v-else-if="header.key === 'reference_document_number' && active_tab === 'Update Logistics Details'">
              <a v-if="item.reference_document_number" @click="fetchreferenceFields(item)" style="color: #1976d2; cursor: pointer;">
                <u>{{ item.reference_document_number }}</u>
              </a>
              <span v-else>-</span>
            </span>

            <span v-else>
              <span v-if="item[header.key]">
                {{ item[header.key] }}
              </span>
              <span v-else>-</span>
            </span>
          </template>

          <template #bottom></template>
          </v-data-table>
        </v-col>
      </v-layout>
  
      <!-- pagination display -->
             <div>
                <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-1 mb-0"
                />
            </div>
  
    </v-card>
  </template>
  <script>
    import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
    import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
    import { mixinHelper } from "@//mixins/mixin-helper.js";

    export default{
      mixins: [mixinHelper],
      components : {
        HeaderComponent
      },
      data(){
        return {
          headerText : 'Reverse Logistics',
          buttonAction : '',
          alert : false,
          alert_message : '',
          tab_index : 0,
          alert_type :'success',
          tabs : [ ],
          selected_field : '',
          field_items : [],
          search_tag :'',
          selected : [],
          filterPopup : false,
          table_data : [],
          headers : [],
          packingRequestTab : ["Items In The Request" , "Update Details"],
          packingRequestHeader : [
            { title : 'Tag ID', key : 'tag_number'},
            { title : 'Article ID', key : 'sku_code'},
            { title : 'Article Description', key :'sku_description'},
            { title : '', key : 'action'},
          ],
          packingRequestTableData : [],
          referenceDocPopup: false,
          requestPopup : false,
          search : '',
          loading : false,
          packing_active_tab : "Items In The Request",
          request_reason : 'packaging',
          assign_to : '',
          pickUpLocList : [],
          pickUpLoc : '',
          deliveryLoc : '',
          deliveryLocList : [],
          logisticsPartner : '',
          logisticsPartnerList : [],
          assignedToList : [],
          isItemValidation : null,
          isFraudValidation : null,
          updateLogisticsPopup : false,
          suggestPickUpPopup : false,
          suggestedPickupDate : null,
          actualPickUpPopup : false,
          actualPickupDate : '',
          actualPickupMin: '',
          actualPickupMax: new Date().toISOString().substr(0, 10),
          isUpdateMode: false,
          dispatchDocumentNumber : '',
          messagePopup : false,
          markAsPacked : true,
          message : '',
          receiptDate : '',
          receiptDatePopup : false,
          dispatchDocument : '',
          receiptFile : '',
          requestTitle : '',
          page: 1,
          totalPages: 1,
          totalCount: '',
          pageSize: defaultPageSize,
          pageSizes: defaultPageSizes,
          logisticPopup: false,
          logisticTabs: [ "Basic Details", // "Items In The Request"
            ],
          activeTab: 'Basic Details',
          itemsHeaders: [
            { title : 'Article ID', key : 'sku_code'},
            { title : 'Article Description', key :'sku_description'},
            { title : 'Weight', key : 'weight'},
            { title : 'Volumetric Weight', key : 'volumetric_weight'},
          ],
          itemsTableData: [],
          itemInformation: '',
          assigneePopup: false,
          itemValidRequest : [],
          fraudValidRequest: [],
          distributionID: '',
          request_reason_list: [],
          tracker_logisticsPartner: '',
          tracker_logisticsPartnerList : [],
          tracker_assign_to: '',
          tracker_assignedToList: '',
          filter_pickup_location: '',
          filter_delivery_location: '',
          filter_delivery_location_items:[],
          request_type_search: '',
          filter_request_types: [],
          status_search: '',
          filter_status: [],
          filter_logistic_partner: '',
          filter_logistic_partner_items:[],
          number: 0,
          datadetailpopup:false,
          item_details:'',
          status: '',
          status_items:[
            "Pending Reverse Pickup",
            "Pending Packaging"
          ],
          status_update_logi:'',
          organization_name:'',
          referenceDocData: [],
          request_type_condi:'',
          items_table_rep:[],
          receiptDateFormat : new Date(),
          suggPickupDateFormat : new Date(),
          actualPickDateFormat : new Date()
        }
      },
      created(){
         this.organization_name = this.$store.state.organization_name
         if(this.organization_name === 'Voltas' || this.$isRelianceClient() || $isWhirlpoolClient()){
           this.tabs = [ 
              "Update Logistics Details"
            ],
            this.loadData("Update Logistics Details",'tab_clicked');
         }else{
          this.tabs = [ 
               "Reverse Pickup",
              "Other Logistics Requests",
              // "Request Tracker",
              "Update Logistics Details"
            ],
            this.loadData("Reverse Pickup",'tab_clicked');
         }
        
        this.fetchSearchFields();
      },
      computed : {
        formatActualPickDate(){
            if (/^\d{2}\/\d{2}\/\d{4}$/.test(this.actualPickupDate)) {
              return this.actualPickupDate;
            } else {
              return this.formatDate(this.actualPickupDate, 'dd/mm/yyyy');
            }
        },
        formatSuggestPickDate(){
          if (/^\d{2}\/\d{2}\/\d{4}$/.test(this.suggestedPickupDate)) {
            return this.suggestedPickupDate;
          } else {
            return this.formatDate(this.suggestedPickupDate, 'dd/mm/yyyy');
          }
        },
        formatReceiptDate(){
          return this.formatDate(this.receiptDate);
        },
      },
      methods : {
        formatDate(date, format = 'dd/mm/yyyy') {
          if (!date) return '';

          const d = new Date(date);
          if (isNaN(d)) return 'Invalid Date';

          const day = d.getDate().toString().padStart(2, '0');
          const month = (d.getMonth() + 1).toString().padStart(2, '0');
          const year = format === 'dd/mm/yy' ? d.getFullYear().toString().slice(-2) : d.getFullYear();

          return `${day}/${month}/${year}`;
        },
        handleSaveDate(dateType , dateFormat, dateState){
          this[dateState] = this[dateFormat]
          this[dateType] = false
        },
        showAlert(alert_type, alert_message) {
          this.alert = true;
          this.alert_type = alert_type;
          this.alert_message = alert_message;
          this.alertTimeOut();
        },
        alertTimeOut() {
          setTimeout(() => {
            this.alert = false;
          }, 3000);
        },
        loadData(tab,tab_clicked){
          if(tab_clicked){
            this.search_tag = '';
            this.selected_field = '';
          }
          this.active_tab = tab;
          this.table_data = [];
          this.selected = [];
          if(tab === "Reverse Pickup"){
            this.headers = [
              { title : 'IRRD', key : 'irrd_number', minWidth: '200px'},
              { title : 'Tag ID', key : 'tag_number', minWidth: '200px'},
              { title : 'Article ID', key : 'sku_code', minWidth: '200px'},
              { title : 'Article Description', key : 'sku_description', minWidth: '200px'},
              { title : 'Status', key : 'status', minWidth: '200px'},
              { title : 'Pick Up Location', key : 'item_location', minWidth: '200px'},
              { title : 'Delivery Location', key : 'delivery_Location', minWidth: '200px'}
            ];
            this.fetchReversePickup();
          } else if(tab === "Other Logistics Requests"){
            this.headers = [
              { title : 'IRRD', key : 'irrd_number', minWidth: '200px'},
              { title : 'Tag ID', key : 'tag_number', minWidth: '200px'},
              { title : 'Article ID', key : 'sku_code', minWidth: '200px'},
              { title : 'Article Description', key : 'sku_description', minWidth: '200px'},
              { title : 'Status', key : 'status', minWidth: '200px'},
              { title : 'Pick Up Location', key : 'item_location', minWidth: '200px'},
              { title : 'Delivery Location', key : 'delivery_location', minWidth: '200px'}
            ];
            this.fetchOtherLogisticsRequest()
          } else if(tab === "Request Tracker"){
            this.headers = [
              { title : 'Request ID', key : 'request_id', minWidth: '200px'},
              { title : 'Creation Date & Time', key : 'created_at', minWidth: '250px'},
              { title : 'Request Type', key : 'request_type', minWidth: '200px'},
              { title : 'Assigned To', key : 'assignee_name', minWidth: '200px'},
              { title : 'Status', key : 'status', minWidth: '200px'},
              { title : 'Completion Date & Time', key : 'completed_at', minWidth: '200px'},
              { title : 'Not Found Items', key : 'not_found_items', minWidth: '200px'},
            ];
            this.fetchRequestTracker()
          } else if(tab === "Update Logistics Details"){
            this.table_data = []
            this.headers = [
              // { title : 'Logistics Request ID', key : 'logistics_request_id'},
              { title : 'Created On', key : 'created_date', minWidth: '200px'},
              { title : 'Ticket No', key : 'client_crm_ticket_no', minWidth: '200px'},
              { title : 'Reference Doc No', key : 'reference_document_number', minWidth: '200px'},
              { title : 'Request type ', key : 'request_type', minWidth: '200px'},
              { title : 'Item Location', key : 'item_location', minWidth: '200px'},
              { title : 'Delivery Location', key : 'delivery_location', minWidth: '200px'},
              { title : 'Suggested Pick Up Date', key : 'suggested_pickup_date', minWidth: '250px'},
              { title : 'Actual Pick Up Date', key : 'actual_pickup_date', minWidth: '200px'},
              { title : 'Logistics Partner', key : 'logistic_partner', minWidth: '200px'},
              { title : 'Assignment Date', key : 'created_date', minWidth: '200px'},
              { title : 'Ageing(Days)', key : 'ageing', minWidth: '200px'},
              { title : 'Status', key : 'item_decision_status', minWidth: '150px'},
            ];
            this.fetchUpdateLogisticsDetail()
          }
        },
        fetchSearchFields(){
          this.$httpSecured
            .get("/api/v1/warehouse/return_initiation/reverse_pickup/get_filters_data")
            .then(response => {
              if (response.data) {
                this.field_items = response.data.search_fields
                this.filter_delivery_location_items = response.data.delivery_locations
                this.filter_logistic_partner_items = response.data.logistics_partners
                // this.loading = false;
              } else {
                // this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        },
        fetchreferenceFields(item){
          this.request_type_condi = item.request_type
          this.itemInformation = item
          this.$httpSecured
            .get(`/api/v1/warehouse/return_initiation/reverse_pickup/${item.id}/get_item_details`)
            .then(response => {
              if (response.data) {
                this.referenceDocData = response.data.data
                this.itemsTableData = response.data.data.items
                this.items_table_rep = response.data.data.rep_items
                this.referenceDocPopup = true;
              } else {
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        },
        fetchUsersLocation(value){
          const requestID = this.selected.map(x => x.id)
          const requestBody = {
            ids: requestID,
            request_type: value
            }
          this.loading = true
          this.$httpSecured
            .get("api/v1/warehouse/return_initiation/reverse_pickup/get_locations_and_users", {params: requestBody})
            .then(response => {
              if (response.data) {
                this.loading = false;
                this.request_reason_list = response.data.pick_up_reasons
                this.assignedToList = response.data.users
                this.field_items = response.data.search_fields
                this.pickUpLocList = response.data.pick_up_reasons
                this.deliveryLocList = response.data.delivery_locations
                this.logisticsPartnerList = response.data.logistics_partners              
                this.packingRequestTableData = response.data.irrd_items
                this.distributionID = response.data.distribution_center.id             
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.requestPopup = false
              this.loading = false;
            });
        },
        fetchFiltersData(){
          const params = {
            logistics : 'true'
          }
          this.$httpSecured
            .get("api/v1/warehouse/put_requests/filters_data", {params})
            .then(response => {
              if (response.data) {
                this.filter_request_types = response.data.request_types
                this.filter_status = response.data.statuses
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.requestPopup = false
              this.loading = false;
            });
        },
        fetchReversePickup(){
          const params = {
            search_in : this.selected_field.id,
            search: this.search_tag,
            page: this.page,
            per_page: this.pageSize,
          };
          this.loading = true;
          this.$httpSecured
            .get("/api/v1/warehouse/return_initiation/reverse_pickup", { params: params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.return_items
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        },
        fetchOtherLogisticsRequest(){
          const params = {
            search_in : this.selected_field.id,
            search: this.search_tag,
            page: this.page,
            per_page: this.pageSize,
          };
          this.loading = true;
          this.$httpSecured
            .get("/api/v1/warehouse/return_initiation/reverse_pickup/other_logistics", { params: params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.return_items
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        },
        fetchRequestTracker(){
          const params = {
            search_in : this.selected_field,
            search: this.search_tag,
            page: this.page,
            per_page: this.pageSize,
          };
          this.loading = true;
          this.$httpSecured
            .get("/api/v1/warehouse/return_initiation/reverse_pickup/requests", { params: params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.put_requests
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.fetchFiltersData()
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        },
        fetchUpdateLogisticsDetail(){
          const params = {
            search: this.search_tag,
            page: this.page,
            per_page: this.pageSize,
          };
          this.loading = true;
          this.$httpSecured
            .get("/api/v1/warehouse/return_initiation/reverse_pickup", { params: params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.return_items
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        },
        filterListOfButtons(){
          this.filterPopup = true;
          this.filter_pickup_location = ''
          this.filter_delivery_location = ''
          this.request_type_search = ''
          this.status_search = ''
          this.filter_logistic_partner = ''
          document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
        },
        createRequest(action){
          
          this.number = 0
          var status_item = Array.from(new Set(this.selected.map(x => x.status)));        
          this.tab_index = 0;
          this.packing_active_tab = "Items In The Request";
          if(action == 'logistics'){
           if(status_item.length > 1){
            this.requestPopup = false;
             this.selected = []
             this.showAlert("error", "Select only Pending Reverse Pickup items");
             return
           }else if(status_item[0] === 'Pending Reverse Pickup'){
            if(this.selected.length === 1){
             this.pickUpLoc = this.selected[0].item_location
            }
             this.requestPopup = true;
            this.buttonAction = 'create_logistics_request';
            this.requestTitle = "Create Reverse Logistics Request";
            // this.pickUpLoc = ''
            this.deliveryLoc = ''
            this.itemValidRequest = ''
            this.fraudValidRequest = ''
            this.logisticsPartner = ''
            this.assign_to = ''
            this.fetchUsersLocation('logistics')         
           }else if(status_item[0] === 'Pending Packaging'){
            this.showAlert("error", "Select only Pending Reverse Pickup items");
           }          
          } 
          if(action == 'packing') {
             if(status_item.length > 1){
            this.requestPopup = false;
             this.selected = []
             this.showAlert("error", "Select only Pending Packaging items");
             return
           }else if(status_item[0] === 'Pending Packaging'){
            this.requestPopup = true;
            this.buttonAction = 'create_packing_request';
            this.requestTitle = "Create Packing Request";
            this.assign_to = '';
            this.fetchUsersLocation('packaging');
           }else if(status_item[0] === 'Pending Reverse Pickup'){
            this.showAlert("error", "Select only Pending Packaging items");
           } 
          }
        },
        updatePackingRequestTab(tab){
          this.packing_active_tab = tab;
        },
        deleteEvent(item){
          console.log(item);
        },
        actualPickupMinDate() {
          if (this.isUpdateMode && this.selected && this.selected.length > 0) {
            return this.selected[0].created_date.slice(0,10).split('/').reverse().join('-');
          }else{
            return this.suggestedPickupDate;
          }
        },
        updateLogisticsDetails(){
          this.number = 0;
          this.updateLogisticsPopup = true;
          this.suggestedPickupDate = null;
          this.actualPickupDate = null;
          this.dispatchDocumentNumber = '';
          this.receiptDate = null;
          this.dispatchDocument = null;
          this.suggPickupDateFormat = new Date()
          this.actualPickDateFormat = new Date()
          this.receiptDateFormat = new Date()
          this.receiptFile = null;
          if (this.selected && this.selected.length > 0) {
            this.isUpdateMode = true;
             if (this.selected[0].suggested_pickup_date) {
              this.suggestedPickupDate = this.selected[0].suggested_pickup_date
            }
          }
          this.actualPickupMin = this.actualPickupMinDate();
          // const params = {
          //   logistic_details : "true",
          // };
          // const ids = this.selected[0].id
          // this.$httpSecured
          //   .get(`/api/v1/warehouse/return_initiation/reverse_pickup/${ids}/request_details`,{ params} )
          //   .then(response => {
          //     if (response.data) {
          //       this.actualPickupDate = response.data.put_request.actual_pickup_date
          //       this.suggestedPickupDate = response.data.put_request.suggested_pickup_date
          //     } else {
          //       this.showAlert("error", "No Data Found");
          //     }
          //   })
          //   .catch(error => {
          //     this.$toast.error(error.response.data.error)
          //     this.unreservePopup = false;
          //   });
        },
        changeAssignee(){
          var status_item = Array.from(new Set(this.selected.map(x => x.status)));
           if(status_item.length > 1){
            this.assigneePopup = false;
             this.selected = []
             this.showAlert("error", "Select only Pending items");
             return
           }else if(status_item[0] === 'Pending'){
            this.assigneePopup = true;
           }else if(status_item[0] === 'In Progress') {
            this.showAlert("error", "Select only Pending items");
            return
           }        
          this.tracker_logisticsPartner = ''
          this.tracker_assign_to = ''
          const assign = this.selected.map(x => x.assignee_name)
          this.tracker_logisticsPartner = ''
          this.tracker_assignedToList = assign
          const requestID = this.selected.map(x => x.id)
          const requestBody = {
            request_id: requestID
            }
          this.$httpSecured
            .get("api/v1/warehouse/return_initiation/reverse_pickup/get_locations_and_users", {params: requestBody})
            .then(response => {
              if (response.data) {
                this.tracker_logisticsPartnerList = response.data.logistics_partners
                this.tracker_assignedToList = response.data.users
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
         
        },
        submitAssignee(){
          this.number ++
          const ids = this.selected.map(item => item.id)
          const assigneID = this.tracker_assign_to
          const logisticPartner = this.tracker_logisticsPartner
          const requestBody = {
            assignee_ids: [assigneID],
            logistics_partner_id: logisticPartner,
          }
          this.$httpSecured
            .put(`/api/v1/warehouse/return_initiation/reverse_pickup/${ids}/update_assignee`, requestBody)
            .then(response => {
              if (response.data) {
                this.assigneePopup = false;
                this.messagePopup = true;
                this.markAsPacked = false;
                this.message = response.data.message;
                this.number = 0;
              } else {
                this.number = 0;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.$toast.error(error.response.data.error)
              this.assigneePopup = false;
              this.number = 0;
            });
        },
        // formatDate(date) {
        //   if (!date) return null
        //   const [year, month, day] = date.split('-')
        //   return `${day}/${month}/${year}`
        // },
        saveAndClose() {
          this.number ++ 
          const ids = this.selected.map(x => x.id);
          const formData = new FormData();
          formData.append('ids', ids)
          formData.append('suggested_pickup_date', this.formatSuggestPickDate)
          formData.append('actual_pickup_date', this.formatActualPickDate)
          formData.append('dispatch_document_number', this.dispatchDocumentNumber)
          formData.append('dispatch_document', this.dispatchDocument)
          formData.append('receipt_date', this.formatReceiptDate)
          formData.append('receipt_document', this.receiptFile)
          this.$httpSecured
            .put("/api/v1/warehouse/return_initiation/reverse_pickup/update_logistic_details", formData)
            .then(response => {
              if (response.data) {
                this.updateLogisticsPopup = false;
                this.messagePopup = true;
                this.markAsPacked = false;
                this.message = response.data.message;
                this.number = 0
              } else {
                this.number = 0
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.$toast.error(error.response.data.error)
              this.updateLogisticsPopup = false;
              this.number = 0
            });
        },
        DetailsPopup(item){
          this.logisticPopup = true
          this.itemInformation = item
          this.itemsHeaders = [
            { title : 'Tag ID', key : 'tag_number'},
            { title : 'Article ID', key : 'sku_code'},
            { title : 'Article Description', key :'sku_description'},
          ]
          // this.itemInformation = item
          // this.itemsTableData = []
          // this.itemsTableData.push(item)
          // const params = {
          //   logistic_details : "true",
          // };
          // const ids = item.id
          // this.$httpSecured
          //   .get(`/api/v1/warehouse/return_initiation/reverse_pickup/${ids}/request_details`,{ params} )
          //   .then(response => {
          //     if (response.data) {
          //       this.itemInformation = response.data.put_request
          //       this.itemsTableData = response.data.put_request.items
          //     } else {
          //       this.showAlert("error", "No Data Found");
          //     }
          //   })
          //   .catch(error => {
          //     this.$toast.error(error.response.data.error)
          //     this.unreservePopup = false;
          //   });
        },
        TicketPopup(item){
          this.$store.commit("setLotIds", {
            lotIds: item,
            action: 'by_link_approve_reverse_logi',
            inventoryId: "Reverse Logistics"
          });
          this.$router.push({ name: "sub_request_approval" });
        },
        DetailsPopupRequestTrack(item){
           this.datadetailpopup = true
           this.item_details = item
        },
        changeTabs(tab){
          this.activeTab = tab;
        },
        submitPackingRequest(){
          this.number ++
          const ids = this.selected.map(item => item.id)
          const assigneID = this.assign_to.id
          if(this.buttonAction === 'create_logistics_request'){
            this.$httpSecured
            .post("/api/v1/warehouse/return_initiation/reverse_pickup/create_logistics_request", 
            {
              pick_up_location : this.pickUpLoc,
              delivery_location_id : this.deliveryLoc.id,
              item_validation_required : this.itemValidRequest,
              fraud_validation_required : this.fraudValidRequest,
              logistics_partner_id : this.logisticsPartner.id,
              assignee_ids : [assigneID],
              distribution_center_id : this.distributionID,
              return_ids : ids
            })
            .then(response => {
              if (response.data) {
                this.requestPopup = false;
                this.messagePopup = true;
                this.markAsPacked = false;
                this.message = response.data.message;
                this.number = 0
              } else {
                this.number = 0
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.$toast.error(error.response.data.error)
              this.requestPopup = false;
              this.number = 0
            });
          }
          if(this.buttonAction === 'create_packing_request'){
            const skuCode = this.selected.map(item => item.sku_code)
            const srNo = this.selected.map(item => item.serial_number)
            const tagNo = this.selected.map(item => item.tag_number)
            this.$httpSecured
            .post("/api/v1/warehouse/return_initiation/reverse_pickup/create_packaging_request", 
              {
                return_reason : this.request_reason,
                distribution_center_id : this.distributionID,
                assignee_ids : [this.assign_to.id],
                return_ids : [ids]
              }
              )
            .then(response => {
              if (response.data) {
                this.requestPopup = false;
                this.messagePopup = true;
                this.markAsPacked = false;
                this.message = response.data.message;
                this.number = 0
              } else {
                this.number = 0
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.$toast.error(error.response.data.error)
              this.requestPopup = false;
              this.number = 0
            });
          }
          // this.requestPopup = false;
          // this.messagePopup = true;
          // this.markAsPacked = false;
          // this.message = "Updated Successfully";
        },
        askForPacking(){
          this.messagePopup = true;
          this.message = "Are you sure, want to mark as packed ?";
          this.markAsPacked = true;
        },
        confirmedMarkAsPacked(){
          this.markAsPacked = false;
          const selected_ids = this.selected.map(item => item.id)
            const params = {
              ids: selected_ids
            }
            this.$httpSecured.post('/api/v1/warehouse/return_initiation/reverse_pickup/mark_as_packed',params)
              .then(response => {
                if (response.data) {
                  this.successpopup = true;
                  this.message = response.data.message;
                } else {
                  this.showAlert("error", "No Data Found");
                }
                this.loading = false;
              })
              .catch(error => {
                this.showAlert("error", "Something went wrong from Network" + error);
                this.loading = false;
              });
        },
        closePopup(){
          this.messagePopup = false
          this.loadData(this.active_tab)
        },
        applyFilterFunc(){
          this.loading = true;
          if (this.active_tab === 'Reverse Pickup'){
            const params = {
              pickup_location : this.filter_pickup_location,
              delivery_location: this.filter_delivery_location.id,
              status: this.status
            };
          this.$httpSecured
            .get("/api/v1/warehouse/return_initiation/reverse_pickup", { params: params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.return_items
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                this.filterPopup = false
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
          } else if (this.active_tab === "Other Logistics Requests"){
            const params = {
              pickup_location : this.filter_pickup_location,
              delivery_location: this.filter_delivery_location.id,
              status: this.status
            };
            this.$httpSecured
            .get("/api/v1/warehouse/return_initiation/reverse_pickup/other_logistics", { params: params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.return_items
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                this.filterPopup = false
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
          } else if (this.active_tab === "Request Tracker"){
            const params = {
              request_type : this.request_type_search.id,
              status: this.status_search.id
            };
            this.$httpSecured
            .get("/api/v1/warehouse/return_initiation/reverse_pickup/requests", { params: params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.put_requests
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                this.filterPopup = false
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
          } else if (this.active_tab === 'Update Logistics Details'){
            const params = {
              pickup_location : this.filter_pickup_location,
              delivery_location : this.filter_delivery_location.id,
              logistics_partner: this.filter_logistic_partner.id,
              status: this.status_update_logi
            };
            this.$httpSecured
            .get("/api/v1/warehouse/return_initiation/reverse_pickup/logistics_requests", { params: params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.put_requests
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.loading = false;
                this.filterPopup = false
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
          }
        },
        handlePageChange() {
          if (this.active_tab === "Reverse Pickup") {
            this.fetchReversePickup();
          } else if (this.active_tab === "Other Logistics Requests") {
            this.fetchOtherLogisticsRequest();
          } else if (this.active_tab === "Request Tracker") {
            this.fetchRequestTracker();
          } else {
            this.fetchUpdateLogisticsDetail();
          }
        },
        handlePageSizeChange() {
          this.page = 1;
          if (this.active_tab === "Reverse Pickup") {
            this.fetchReversePickup();
          } else if (this.active_tab === "Other Logistics Requests") {
            this.fetchOtherLogisticsRequest();
          } else if (this.active_tab === "Request Tracker") {
            this.fetchRequestTracker();
          } else {
            this.fetchUpdateLogisticsDetail();
          }
        },
        submitMarkPacked(){
            const selected_ids = this.selected.map(item => item.id)
            const params = {
              ids: selected_ids
            }
            this.$httpSecured.post('/api/v1/issue_inventories/update_status',params)
              .then(response => {
                if (response.data) {
                  this.successpopup = true;
                  this.successmessage = response.data.message;
                } else {
                  this.showAlert("error", "No Data Found");
                }
                this.loading = false;
              })
              .catch(error => {
                this.showAlert("error", "Something went wrong from Network" + error);
                this.loading = false;
              });
          },
      },
    }
  </script>
  
  <style scoped>
    .custom-control_outlined button {
      min-height: 52px;
      border-width: 1px;
      border-color: rgba(0, 0, 0, 0.42);
      border-style: solid;
    }
  
    .v-dialog:has(.filter-data) {
      justify-content: right;
      align-items: baseline;
      top: var(--dialog-ypos);
  }
  .item-selected {
    margin-top: 23px;
    position: absolute;
    left: 41%;
  }
  
  @media (max-height: 1104px) {
    .PaddingItemPerPage {
      padding: 8px !important;
    }
  }
  
  @media (min-height: 1126px) {
    .PaddingItemPerPage {
      padding: 24px !important;
    }
  }
  .assets {
    font-size: 12px;
    color: #ccc;
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 315px) !important;
  }
  .replacement-style{
    font-weight: 500;
    font-size: 16px;
    color: #000
  }
  </style>